const features = [
  {
    icon: 'ri-time-line',
    title: '实时域名更新',
    desc: '第一时间追踪51cg域名变更，确保导航信息始终准确有效，告别找不到入口的烦恼。',
  },
  {
    icon: 'ri-shield-flash-line',
    title: '多重安全验证',
    desc: '每个收录域名均经过多轮可用性与安全性验证，有效过滤仿冒站点与钓鱼链接。',
  },
  {
    icon: 'ri-guide-line',
    title: '全面平台指南',
    desc: '提供从入门到进阶的51cg使用教程，涵盖功能解析、操作技巧与常见问题解答。',
  },
  {
    icon: 'ri-device-line',
    title: '多端无缝适配',
    desc: '无论是桌面浏览器还是移动设备，都能获得一致的导航体验与最新入口信息。',
  },
];

export default function FeatureSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">为什么选择本站作为51cg网址导航</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="group p-6 bg-background-100 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all duration-200 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}